import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "meetDriverFilled"
const MeetDriverFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.337 7.875C15.953 7.875 16.452 8.375 16.452 8.99V14.629C16.452 14.834 16.619 15 16.824 15S17.195 14.834 17.195 14.629V10.865C17.195 10.249 17.695 9.75 18.31 9.75 18.926 9.75 19.425 10.25 19.425 10.865V16.928L20.544 15.799C20.98 15.358 21.69 15.358 22.127 15.8L22.171 15.843C22.587 16.263 22.61 16.939 22.22 17.387L18.828 21.295C18.28 22.026 17.408 22.5 16.425 22.5H14.25C13.052 22.5 12.018 21.797 11.537 20.782L11.513 20.728 11.48 20.653 11.457 20.596 11.42 20.496 11.402 20.443 11.376 20.362 11.354 20.286Q11.34 20.233 11.33 20.18L11.32 20.148 11.297 20.028 11.29 19.992 11.273 19.868 11.268 19.828 11.258 19.721Q11.252 19.611 11.25 19.5 11.25 19.385 11.26 19.271 11.25 19.205 11.25 19.136V11.615Q11.25 11.44 11.3 11.283 11.333 11.179 11.384 11.083C11.556 10.769 11.876 10.545 12.251 10.507Q12.307 10.5 12.365 10.5L12.465 10.504 12.472 10.505 12.502 10.51 12.575 10.52 12.641 10.537 12.662 10.54C13.133 10.671 13.48 11.102 13.48 11.615V14.629C13.48 14.834 13.646 14.999 13.85 15 14.057 15 14.224 14.834 14.224 14.629V8.989C14.223 8.375 14.722 7.876 15.337 7.876M8.662 6.75C9.277 6.75 9.776 7.25 9.776 7.865V11.25Q9.75 11.429 9.75 11.615V19.135Q9.75 19.218 9.756 19.294 9.751 19.394 9.75 19.5C9.75 20.159 9.893 20.783 10.147 21.347Q9.952 21.374 9.75 21.375H7.574C6.591 21.375 5.718 20.901 5.171 20.17L1.778 16.262C1.389 15.814 1.41 15.139 1.828 14.718L1.871 14.674C2.31 14.234 3.018 14.233 3.455 14.674L4.575 15.803V9.74C4.574 9.124 5.072 8.625 5.688 8.625 6.304 8.625 6.804 9.125 6.804 9.74V13.504C6.804 13.709 6.97 13.874 7.174 13.875 7.38 13.875 7.548 13.709 7.548 13.504V7.864C7.547 7.25 8.047 6.75 8.662 6.75M18.97 4.72C19.263 4.427 19.738 4.427 20.03 4.72S20.323 5.487 20.03 5.78L18.155 7.655C17.862 7.948 17.388 7.948 17.095 7.655S16.802 6.888 17.095 6.595zM15.454 2.665C15.64 2.295 16.09 2.144 16.461 2.329S16.98 2.965 16.796 3.335L15.671 5.585C15.486 5.955 15.035 6.106 14.665 5.921S14.144 5.285 14.329 4.915zM12.75 1.5C13.164 1.5 13.5 1.836 13.5 2.25V4.5C13.5 4.914 13.164 5.25 12.75 5.25S12 4.914 12 4.5V2.25C12 1.836 12.336 1.5 12.75 1.5" />
        </svg>
      }
    </span>
  )
}
export default MeetDriverFilledIcon
